var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarMessagerie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "-2 -2 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48615 0 0 4.48615 0 10C0 11.6377 0.431346 13.1674 1.13086 14.5322L0.046875 18.4141C-0.205598 19.3158 0.685965 20.2063 1.58789 19.9541L5.47168 18.8701C6.83545 19.5687 8.36353 20 10 20C15.5139 20 20 15.5139 20 10C20 4.48615 15.5139 0 10 0ZM10 1.5C14.7031 1.5 18.5 5.29688 18.5 10C18.5 14.7031 14.7031 18.5 10 18.5C8.49854 18.5 7.09613 18.1091 5.87207 17.4268C5.69922 17.3303 5.49531 17.3061 5.30469 17.3594L1.61133 18.3906L2.64258 14.6992C2.69586 14.5086 2.67164 14.3047 2.5752 14.1318C1.89183 12.9067 1.5 11.5023 1.5 10C1.5 5.29688 5.29688 1.5 10 1.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMessagerie);
export default __webpack_public_path__ + "static/media/sidebar-messagerie.b2afb48edd6f419526f256f7dcb10a34.svg";
export { ForwardRef as ReactComponent };